import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import VectorSource from 'ol/source/Vector';
import { VectorLayerDMTR } from 'src/app/menu/view-menu/layer';
import { ConfigurationLayerModel } from 'src/app/models/configuration';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { CoordenateService } from 'src/app/services/coordenate.service';

@Component({
  selector: 'popup-configuration-layer',
  templateUrl: './configuration-layer.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class PopupConfigurationLayerComponent {

  configurationLayerForm : UntypedFormGroup;
  activeChanged: boolean = false; //TODO
  @Input() editMode : boolean;
  @Input() layer : ConfigurationLayerModel;
  @Input() selectedRow : number = -1;

  constructor(public configurationController : ConfigurationService,
     public bsModalRef : BsModalRef,
     public http: HttpClient,
     private rcsControl: CoordenateService
     ) {
    this.layer = new ConfigurationLayerModel();

    this.configurationLayerForm = new UntypedFormGroup({
      name: new UntypedFormControl(this.layer.name,[Validators.required]),
      url: new UntypedFormControl(this.layer.path,[Validators.required]),
      type : new UntypedFormControl(this.layer.type,[Validators.required]),
      active : new UntypedFormControl(this.layer.active,[Validators.required])
    });
  }

  cancel():void{
    this.bsModalRef.hide();
  }

  saveLayer():void {
    if(!this.editMode){
      this.configurationController.currentConfiguration.layers.push(this.layer);
    }
    else{
      this.configurationController.currentConfiguration.layers[this.selectedRow] = this.layer;
    }
    this.bsModalRef.hide();
  }
}
